(function($) {
	$('.hamburger').on('click', function(e) {
    e.preventDefault();

    if( $('body').hasClass('navigationpanel-open') ) {
      window.panel_close('NavigationPanel');
    } else {
      window.panel_open('NavigationPanel')
    }
  });

  // Logo large to small
  $(window).scroll(function(){
    //more then or equals to
    if($(window).scrollTop() >= 100 ){
      $('.logo').addClass('ipf');
      $('.header').addClass('gradient');
    } else {
      $('.logo').removeClass('ipf');
      $('.header').removeClass('gradient');
    }
  });

})(jQuery);